import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import InputForms from "../../UiComponents/forms/InputForms";
import styles from "./SelectConfigCabine.module.scss";

const SelectConfigCabine = ({
  cabId,
  cabine,
  setCabId,
  isSearchingSettingCab,
  setIsSearchingSettingCab,
}) => {
  const { t } = useTranslation();
  const [searchCab, setSearchCab] = useState("");

  // change de cabine avec le select
  const cabIdValueSpeaker = (e) => {
    setCabId(e.target.value);
    setSearchCab("");
  };

  useEffect(() => {
    setSearchCab("");
  }, [cabine]);


  return (
    <div
      className={styles.selectCab}
      onClick={() => setIsSearchingSettingCab(false)}
    >
      <div className={styles.selectCabContainer}>
      <select
        value={cabId}
        onChange={cabIdValueSpeaker}
        size={isSearchingSettingCab ? 10 : 0}
        onBlur={() => setIsSearchingSettingCab(false)}
        
      >
       <option value="">{t("superadmin_ui.select_cabine_option")}</option>
        {cabine &&
          cabine
            .filter((c) => c.cabname.toLowerCase().includes(searchCab))
            .map((cab, index) => {
              return (
                <option key={index} value={cab.id}>
                  {cab.cabname} ({cab.id})
                </option>
              );
            })}
      </select>

      <InputForms
        value={searchCab}
        onChange={(e) => {
          setSearchCab(e.target.value);
          setIsSearchingSettingCab(true);
        }}
        placeholder={t("superadmin_ui.search_cabines_placeholder")}
        id={styles.selectCabInput}
      />
      </div>
    </div>
  );
};

export default SelectConfigCabine;
